import React from "react";
import { Header } from "semantic-ui-react";
import { ICartLocationHistory } from "../../../lib/interfaces/SortCart/ISortCartResultModel";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import "./CartLocationHistoryModal.css";

interface IProps {
  open: boolean;
  cartLocationHistory: ICartLocationHistory[];
  onClose: () => void;
}

const CartLocationHistoryModal = ({ open, cartLocationHistory, onClose }: IProps) => {
  return (
    <ConfirmModal
      size="small"
      open={open}
      closeOnDimmerClick={true}
      closeOnEscape={true}
      header={<Header icon="info circle" color="blue" content="Vagnens senaste positioner" />}
      content={
        <div className="CartLocationHistoryModal">
          {cartLocationHistory &&
            cartLocationHistory.map((loc, index) => (
              <div key={index} className="item">
                <h3 className="column one">
                  {loc.parkPosition === "P" && <span className="inverted">{loc.parkPosition}</span>}
                  {loc.parkLocation}
                  {loc.parkPosition !== "P" && <span>{loc.parkPosition}</span>}
                </h3>
                <span className="column two">{loc.historyDate}</span>
              </div>
            ))}
        </div>
      }
      cancelCallback={onClose}
    />
  );
};

export default CartLocationHistoryModal;
